import { DASHBOARD_MESSAGES } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { OptionsChart } from "@/modules/DashboardTemplate/models/optionsChart";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { LEGEND_CHART, TITLE_CHART } from "../ChartsConstants";
import { handleClickChart } from "../Utils/handleClick";

@Component({
  name: "DoughnutChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshCharts: "getRefreshCharts"
    })
  },
  components: {
    EmptyState
  }
})
export default class DoughnutChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  refreshCharts!: number;

  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;

  @Prop() propertiesToChart!: PropertiesChart;

  chartOptions: OptionsChart = new OptionsChart();
  emptyData = false;

  mounted() {
    this.chart();
  }

  @Watch("refreshCharts")
  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    const dataToGraph = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[this.propertiesToChart.indexCollectionFilter];
    console.log("mounted dona", dataToGraph);

    if (Object.keys(dataToGraph.chartData).length === 0) {
      this.emptyData = true;
      return;
    }
    this.emptyData = false;

    const seriesData = [];
    for (let i = 0; i < dataToGraph.chartData.xAxis.length; i++) {
      seriesData.push({
        name: dataToGraph.chartData.xAxis[i],
        value: dataToGraph.chartData.data[0].data[i]
      });
    }
    const color = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      color,
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      tooltip: {
        trigger: "item"
      },
      legend: {
        ...LEGEND_CHART
      },
      series: [
        {
          name: dataToGraph.chartName,
          type: "pie",
          radius: ["40%", "70%"],
          center: ["35%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: "bold"
            }
          },
          data: seriesData
        }
      ]
    };
  }

  handleClick(event: any) {
    handleClickChart(
      this.propertiesToChart.indexSectionOfDashboard,
      this.propertiesToChart.indexCollectionFilter,
      "doughnut",
      event
    );
  }
}
